// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Bd uC","wrapperNeon":"Be uO","ribbon":"Bf uL","title":"Bh uE","seasons":"Bi uJ","genres":"Bj uK","buttonWrapper":"Bk uG","button":"Bl uH","buttonNeon":"Bm uP"};